module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAyBAMAAAAAZPCUAAAAGFBMVEX19fX19fX19fX19fX19fX19fX19fX19fXEdSvzAAAAB3RSTlMABS93f8/6/nek9QAAAMFJREFUOMuNzlsRwzAQQ1FDKIRwMIJSKIZSSE2/jev4sdZqpe8zmpvSkbS9H5orL9F9npor56G5IiX+nJR4OSXxckpidULi38WJzYWJzYWJt4sSuwsSh+OJw/HEydHE2bHExZHExZHE1fmJxrmJ1nmJ1nmJm3MSd4cTgYOJwMFE5FAidCARuz0Ruz3RcVui52yi60yi60yi79ZE4pZE5uZE5uZE6qZE7kZi4Hpi4Hpi5O7E0LXE2NXEHLty5izc1X0BaD2yGt+MeWMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/triangle2.png
// module id = 680
// module chunks = 0